const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

if (urlParams.has('lead')) {
    const lead = urlParams.get('lead');
    sessionStorage.setItem('lead_id', lead);
} 